// work data
export const Work = [
  {
    id: 3,
    name: "Global Disaster Tracker",
    description:
      "Global Disaster Tracker was built using Python and Flask for API interactions and data fetching. The API we used was NASA’s EONET which is the Earth Observatory Natural Event Tracker updates in real-time. Created a webpage that has a complete list of these catastrophes, from there you can filter out events by the type of catastrophe, the coordinates, a radius around the coordinates as well as a time frame filter,",
    tags: ["Python", "API", "Flask", "NASA’s EONET"],

    demo: "https://github.com/ashwinnn28/Global-Disaster-Tracker",
    github: "https://github.com/ashwinnn28/Global-Disaster-Tracker",
    image : "https://res.cloudinary.com/dqvpvazim/image/upload/e_improve:outdoor/Screenshot_20230915_022415_x76y04.jpg"
  },
  {
    id: 4,
    name: "Fitness website",
    description:
      "Users can input their weight and height into the BMI calculator, which then computes their BMI score.",
    tags: ["HTML","CSS","Javascript"],

    demo: "https://ashwinnn28.github.io/Fitness-Website/",
    github: "https://github.com/ashwinnn28/Fitness-Website",
    image : "https://res.cloudinary.com/dqvpvazim/image/upload/e_improve:outdoor/Screenshot_20230919_213518_u89icd.jpg"
  },
]